// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SIAFlightMap from './Screens/SIAFlightMapScreen';
import AboutPage from './Screens/AboutPage';
import { FlightProvider } from './Contexts/FlightContext';
import { AuthProvider } from './Contexts/AuthContext';
import { Analytics } from "@vercel/analytics/react"

export default function App() {
  return (
    <AuthProvider>
      <FlightProvider>
        <Router>
          <Routes>
            <Route path="/" element={<SIAFlightMap />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </Router>
        <Analytics />
      </FlightProvider>
    </AuthProvider>
  );
}